import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
$("header .nav li").eq(3).addClass("active");

//技术支持
var technologyTop = $(".technology").offset().top
var produceTop = $(".produce").offset().top
var serveTop = $(".serve").offset().top
var partnerTop = $(".partner").offset().top
var istrue = true;
$(window).on("scroll",
function() {
    var s = $(window).scrollTop();
    if (s >= technologyTop - $(".technology .section1").height() / 2 - 100 && s < produceTop - $(".produce .section1").height()    && istrue) {
        $(".technology .timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        istrue = false;
        console.log(1);

    }else if (s >= produceTop - $(".produce .section1").height()   && s < serveTop -  $(".produce").height()   && !istrue) {
        $(".produce .timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        console.log(2);
        istrue = true;
    }else if (s >= serveTop - $(".produce").height()   && s < partnerTop  && istrue ) {
        $(".serve .timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        console.log(3);
        istrue = false;
    };
    // console.log(s);
    // console.log(serveTop);
    // console.log(partnerTop);
})
//设置计数
$.fn.countTo = function (options) {
    options = options || {};
    return $(this).each(function () {
        //当前元素的选项
        var settings = $.extend({}, $.fn.countTo.defaults, {
            from:            $(this).data('from'),
            to:              $(this).data('to'),
            speed:           $(this).data('speed'),
            refreshInterval: $(this).data('refresh-interval'),
            decimals:        $(this).data('decimals')
    }, options);
    //更新值
    var loops = Math.ceil(settings.speed / settings.refreshInterval),
    increment = (settings.to - settings.from) / loops;
    //更改应用和变量
    var self = this,
    $self = $(this),
    loopCount = 0,
    value = settings.from,
    data = $self.data('countTo') || {};
    $self.data('countTo', data);
    //如果有间断，找到并清除
    if (data.interval) {
        clearInterval(data.interval);
    };
    data.interval = setInterval(updateTimer, settings.refreshInterval);
    //初始化起始值
    render(value);
    function updateTimer() {
        value += increment;
        loopCount++;
        render(value);
        if (typeof(settings.onUpdate) == 'function') {
            settings.onUpdate.call(self, value);
        }
        if (loopCount >= loops) {
            //移出间隔
            $self.removeData('countTo');
            clearInterval(data.interval);
            value = settings.to;
            if (typeof(settings.onComplete) == 'function') {
                settings.onComplete.call(self, value);
            }
        }
    }
    function render(value) {
        var formattedValue = settings.formatter.call(self, value, settings);
        $self.html(formattedValue);
    }
    });
};
$.fn.countTo.defaults={
    from:0,               //数字开始的值
    to:0,                 //数字结束的值
    speed:1000,           //设置步长的时间
    refreshInterval:100,  //隔间值
    decimals:0,           //显示小位数
    formatter: formatter, //渲染之前格式化
    onUpdate:null,        //每次更新前的回调方法
    onComplete:null       //完成更新的回调方法
};
function formatter(value, settings){
    return value.toFixed(settings.decimals);
}
//自定义格式
$('#count-number').data('countToOptions',{
    formmatter:function(value, options){
        return value.toFixed(options.decimals).replace(/\B(?=(?:\d{3})+(?!\d))/g, ',');
    }
});
//定时器
$('.timer').each(count);
function count(options){
    var $this=$(this);
    options=$.extend({}, options||{}, $this.data('countToOptions')||{});
    $this.countTo(options);
}

var swiper = new Swiper(".technology .swiper", {
    slidesPerView: 4,
    spaceBetween: 22,
    loop:true,
    speed:1000,
    autoplay: {
        delay: 2000,
        disableOnInteraction: false,
    },
    pagination: {
        el: ".technology .swiper-pagination",
        type: "progressbar",
    },
    breakpoints: {
        320: { //当屏幕宽度大于等于320
        slidesPerView: 2,
        spaceBetween: 10,
        },
        768: { //当屏幕宽度大于等于768 
            slidesPerView: 3,
            spaceBetween: 15,
        },
        1280: { //当屏幕宽度大于等于1280
            slidesPerView: 4,
            spaceBetween: 22,
        }
    },
});
// 生产能力

var swiper = new Swiper(".produce .swiper", {
    slidesPerView: 4,
    spaceBetween: 22,
    loop:true,
    speed:1000,
    autoplay: {
        delay: 2000,
        disableOnInteraction: false,
    },
    pagination: {
        el: ".produce .swiper-pagination",
        type: "progressbar",
    },
    breakpoints: {
        320: { //当屏幕宽度大于等于320
        slidesPerView: 2,
        spaceBetween: 10,
        },
        768: { //当屏幕宽度大于等于768 
            slidesPerView: 3,
            spaceBetween: 15,
        },
        1280: { //当屏幕宽度大于等于1280
            slidesPerView: 4,
            spaceBetween: 22,
        }
    },
});
// 服务项目
var swiper = new Swiper(".serve .mySwiper1", {
    slidesPerView: 6,
    spaceBetween: 80,
    observer: true,
    observeParents: true,
    speed:500,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    pagination: {
        el: ".swiper1 .swiper-pagination",
        type: "progressbar",
    },
    breakpoints: {
      320: { //当屏幕宽度大于等于320
        slidesPerView: 2,
        spaceBetween: 10,
      },
      768: { //当屏幕宽度大于等于768 
        slidesPerView: 3,
        spaceBetween: 10,
      },
      1280: { //当屏幕宽度大于等于1280
        slidesPerView: 6,
        spaceBetween: 40,
      },
      1600: { //当屏幕宽度大于等于1280
         slidesPerView: 6,
        spaceBetween: 80,
      }
  },
});
var swiper = new Swiper(".serve .mySwiper2", {
    slidesPerView: 6,
    spaceBetween: 80,
    observer: true,
    observeParents: true,
    speed:500,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    pagination: {
        el: ".swiper2 .swiper-pagination",
        type: "progressbar",
    },
    breakpoints: {
      320: { //当屏幕宽度大于等于320
        slidesPerView: 2,
        spaceBetween: 10,
      },
      768: { //当屏幕宽度大于等于768 
        slidesPerView: 3,
        spaceBetween: 10,
      },
      1280: { //当屏幕宽度大于等于1280
        slidesPerView: 6,
        spaceBetween: 40,
      },
      1600: { //当屏幕宽度大于等于1280
         slidesPerView: 6,
        spaceBetween: 80,
      }
  },
});
var swiper = new Swiper(".serve .mySwiper3", {
    slidesPerView: 4,
    spaceBetween: 22,
    observer: true,
    observeParents: true,
    speed:500,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    pagination: {
        el: ".swiper3 .swiper-pagination",
        type: "progressbar",
    },
    breakpoints: {
      320: { //当屏幕宽度大于等于320
        slidesPerView: 2,
        spaceBetween: 10,
      },
      768: { //当屏幕宽度大于等于768 
        slidesPerView: 3,
        spaceBetween: 10,
      },
      1280: { //当屏幕宽度大于等于1280
        slidesPerView: 4,
        spaceBetween: 10,
      },
      1600: { //当屏幕宽度大于等于1280
         slidesPerView: 4,
        spaceBetween: 22,
      }
  },
});
$(".serve ul li").eq(0).addClass("active");
$(".serve .section2 .swiper-box").eq(0).addClass("active");
$(".serve ul li").click(function() {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $(".serve .section2 .swiper-box").eq(index).addClass("active").siblings().removeClass("active");
})


// 合作伙伴
var swiper = new Swiper(".partner .mySwiper", {
    slidesPerView: 5,
    direction: 'horizontal',
    grid: {
        fill: 'row',//column
        rows: 3,
    },
    spaceBetween: 50,
    observer: true,
    observeParents: true,
    speed:500,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    breakpoints: {
      320: { //当屏幕宽度大于等于320
        slidesPerView: 2,
        spaceBetween: 10,
      },
      768: { //当屏幕宽度大于等于768 
        slidesPerView: 3,
        spaceBetween: 10,
      },
      1280: { //当屏幕宽度大于等于1280
        slidesPerView: 4,
        spaceBetween: 10,
      },
      1600: { //当屏幕宽度大于等于1280
         slidesPerView: 5,
        spaceBetween: 50,
      }
  },
  });
